//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
let d=[[[0,"BuildStatus",0,0],[0,"Clearance",1,0],[0,"DesignStatus",1,0],[0,"Diameter",1,0],[0,"DisplayStatus",1,0],[0,"Height",1,0],[0,"XCount",1,0],[0,"XDistance",1,0],[0,"XOffset",1,0],[0,"YCount",1,0],[0,"YDistance",1,0],[0,"YOffset",1,0]],[[[],"CreateChild",{R_:{diepressuresystemchild:"Die.PressureSystemChildBuilder"}},0,0],[["diepressuresystemchild"],"DeleteChild",{},1,0],[["num_children"],"GetChildren",{R_:{children:"Die.PressureSystemChildBuilder[]"}},0,0]],[]];
SPLM.Die.PressureSystemParentBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.PressureSystemParentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;